import { actions } from './actions';

const INITIAL_STATE = {
  snackbar: {
    showSnackbar: false,
    message: '',
  },
  searchParams: '',
  appLoading: true,
  showDemoModal: false,
  showProvideFeedbackModal: false,
  showSubmitFeedback: false,
  contact: {
    showContactModal: false,
    success: true,
  },
  isChromeExtensionActive: false,
  inspectChangesCount: 0,
  inspectExitCallback: null,
  video: {
    showVideoModal: false,
    source: '',
  },
  showTrelloGuide: false,
  showAsanaGuide: false,
  similarPages: {
    show: false,
    pages: [],
    url: '',
  },
  showKeyboardShortcuts: false,
  extension: {
    accessible: false,
    installed: false,
  },
};

export default function appReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case actions.SHOW_SNACKBAR:
      return { ...state, snackbar: { showSnackbar: true, message: payload } };
    case actions.HIDE_SNACKBAR:
      return { ...state, snackbar: { showSnackbar: false, message: '' } };
    case actions.UPDATE_SEARCH_PARAMS:
      return { ...state, searchParams: payload };
    case actions.TOGGLE_APP_LOADING:
      return { ...state, appLoading: payload };
    case actions.TOGGLE_DEMO_MODAL:
      return { ...state, showDemoModal: payload };
    case actions.TOGGLE_PROVIDE_FEEDBACK_MODAL:
      return { ...state, showProvideFeedbackModal: payload };
    case actions.TOGGLE_SUBMIT_FEEDBACK:
      return { ...state, showSubmitFeedback: payload };
    case actions.CONTACT_UPDATE:
      return { ...state, contact: payload };
    case actions.CHROME_EXTENSION_ACTIVE:
      return { ...state, isChromeExtensionActive: payload };
    case actions.INSPECT_CHANGES_COUNT:
      return { ...state, inspectChangesCount: payload };
    case actions.INSPECT_EXIT_CALLBACK:
      return { ...state, inspectExitCallback: payload };
    case actions.TOGGLE_VIDEO_MODAL:
      return { ...state, video: payload };
    case actions.TOGGLE_TRELLO_GUIDE:
      return { ...state, showTrelloGuide: payload };
    case actions.TOGGLE_ASANA_GUIDE:
      return { ...state, showAsanaGuide: payload };
    case actions.TOGGLE_MULTIPLE_PAGES_MODAL:
      return { ...state, similarPages: payload };
    case actions.TOGGLE_KEYBOARD_SHORTCUTS:
      return { ...state, showKeyboardShortcuts: payload };
    case actions.UPDATE_EXTENSION_INFO:
      return { ...state, extension: { ...state.extension, ...payload } };
    default:
      return state;
  }
}
